import { useEffect, useState } from 'react'
import { stopTalkAudioIfSrc } from './helpAudio'
import { loadLocalAudio } from './useTalkAudioStore'

export function useLocalPlayUrl(messageId?: string | null, enabled = true): string | null {
  const [url, setUrl] = useState<string | null>(null)
  useEffect(() => {
    if (!enabled || !messageId) {
      setUrl(null)
      return
    }
    let live = true
    let created: string | null = null
    void loadLocalAudio(messageId).then(u => {
      if (!live) {
        if (u) URL.revokeObjectURL(u)
        return
      }
      created = u
      setUrl(u)
    })
    return () => {
      live = false
      stopTalkAudioIfSrc(created)
      if (created) URL.revokeObjectURL(created)
    }
  }, [messageId, enabled])
  return url
}
